export default {
  title: 'Mentions légales',
  subtitle:
    'Elles apparaissent dans le pied de page de votre boutique en ligne et de votre site uniquement après enregistrement.',
  card_title: 'Mentions légales',
  placeholder: 'Saisissez vos mentions légales',
  status: {
    saved: 'Enregistré',
    not_shown: 'Pas encore affichées dans votre boutique ni sur votre site',
    unsaved: 'Modifications non enregistrées — votre boutique et votre site affichent la dernière version enregistrée',
  },
  save: 'Enregistrer',
  retry: 'Réessayer',
  preview: {
    title: 'Aperçu du pied de page (boutique et site)',
    terms: 'Conditions',
    privacy: 'Confidentialité',
    cookies: 'Cookies',
    imprint: 'Mentions légales',
  },
  toasts: {
    saved: 'Mentions légales enregistrées',
    save_failed: "Impossible d'enregistrer les mentions légales. Veuillez réessayer.",
    load_failed: 'Impossible de charger les mentions légales. Veuillez recharger la page.',
  },
};
